import { Component } from '@angular/core';
import { CoachingIntervalsEditor } from '../coaching-intervals-editor/coaching-intervals-editor';

@Component({
  selector: 'app-fullscreen-coaching-intervals-modal',
  imports: [CoachingIntervalsEditor],
  templateUrl: './fullscreen-coaching-intervals-modal.html',
  styleUrl: './fullscreen-coaching-intervals-modal.scss',
})
export class FullscreenCoachingIntervalsModal {}
